/** De um atleta salvo no criador para quem entra em campo, e os dois clubes da partida. */
import { EXAMPLE_KITS, type Position } from "@besenliga/shared";
import type { KitId, SavedAthlete } from "../creator/roster";
import type { Clubs, PilotSetup } from "./view";

export interface Pilot extends PilotSetup {
  name: string;
  kitId: KitId;
}

/** Nome curto (placar) e completo (telas) dos clubes de exemplo. */
export const CLUB_NAMES: Record<KitId, { short: string; full: string }> = {
  "corujas-campinas": { short: "Corujas", full: "Corujas de Campinas" },
  "lobos-guaiba": { short: "Lobos", full: "Lobos do Guaíba" },
};

export function pilotFrom(saved: SavedAthlete | undefined, role?: Position): Pilot {
  if (saved)
    return {
      name: saved.name,
      kitId: saved.kit,
      kit: EXAMPLE_KITS[saved.kit],
      role: role ?? saved.position,
      spec: {
        sexo: saved.sex,
        altura: saved.height,
        biotipo: saved.build,
        posicao: saved.position,
        skinTone: saved.skinTone,
        hairStyle: saved.hairStyle,
        hairColor: saved.hairColor,
        faceShape: saved.faceShape,
        beard: saved.beard,
        goggles: saved.goggles,
      },
    };
  return {
    name: "Atleta de teste",
    kitId: "corujas-campinas",
    kit: EXAMPLE_KITS["corujas-campinas"],
    role: role ?? "artilheiro",
    spec: {
      sexo: "mulher",
      altura: "medio",
      biotipo: "medio",
      posicao: "artilheiro",
      skinTone: "pele-4",
      hairStyle: "coque",
      hairColor: "castanho",
      faceShape: "oval",
      beard: false,
      goggles: true,
    },
  };
}

/** Seu clube (pelo uniforme do seu atleta) contra o outro clube de exemplo. */
export function clubsFor(kitId: KitId): Clubs {
  const other: KitId = kitId === "corujas-campinas" ? "lobos-guaiba" : "corujas-campinas";
  return {
    casa: { name: CLUB_NAMES[kitId].short, kit: EXAMPLE_KITS[kitId] },
    fora: { name: CLUB_NAMES[other].short, kit: EXAMPLE_KITS[other] },
  };
}

export const otherClub = (kitId: KitId): KitId =>
  kitId === "corujas-campinas" ? "lobos-guaiba" : "corujas-campinas";
